export const catchAxiosError = async (func) => {
  try {
    const response = await func;
    return response;
  } catch (error) {
    const message =
      error?.response?.data?.error?.message || 'Something went wrong';
    throw new Error(message);
  }
};
